// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__CHZUz","socialMedia":"Footer_socialMedia__MIacN","socialIcon":"Footer_socialIcon__xeuWG","socialImage":"Footer_socialImage__j3n-9"};